import { q as U, a as k, u as b, o as v, b as L, c as t, e, f as n, j as l, g as a } from "./define-element-XpjsV6s1.js";
import { u as F } from "./use-user-CwEHAZOt.js";
const O = {
  ref: "container",
  class: "offset-account-login"
}, B = { key: 0 }, E = { key: 1 }, I = ["href"], M = { key: 2 }, R = ["href"];
var r, u, d, f;
const V = {
  __name: "AccountLogin",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    accountUrl: {
      type: String,
      default: (u = (r = window.OFFSET) == null ? void 0 : r.accountUrl) != null ? u : "/account"
    },
    loginUrl: {
      type: String,
      default: (f = (d = window.OFFSET) == null ? void 0 : d.loginUrl) != null ? f : "/login"
    }
  },
  setup(g) {
    const s = g, { isPending: p, loginMutation: _, logoutMutation: h, isValidUser: S } = F(), { mutate: T } = _, { mutate: i, isSuccess: m } = h;
    U(m, (o) => {
      o && window.location.reload();
    }), k(!1);
    const y = b("container");
    return v(() => {
      L(y.value, s.inheritStyle);
    }), (o, c) => (t(), e("div", O, [
      n(p) ? (t(), e("div", B, "Loading...")) : n(S) ? (t(), e("div", E, [
        l(o.$slots, "before-logout", {}, () => [
          a("a", {
            href: s.accountUrl
          }, "Account", 8, I)
        ]),
        a("button", {
          type: "button",
          class: "offset-account-logout",
          onClick: c[0] || (c[0] = (...w) => n(i) && n(i)(...w))
        }, "Log Out")
      ])) : (t(), e("div", M, [
        l(o.$slots, "before-login"),
        a("a", {
          href: s.loginUrl
        }, "Log In", 8, R)
      ]))
    ], 512));
  }
};
export {
  V as _
};
